import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../apiConfig";

const initialState = {
  isLoading: false,
  address: null,
  error: null,
};

export const getAddress = createAsyncThunk(
  "getAddress",
  async (_, thunkApi) => {
    try {
      const res = await api.get("collections/shipping-addresses");
      return res.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createAddress = createAsyncThunk(
  "createAddress",
  async (values, thunkApi) => {
    try {
      const res = await api.post("collections/shipping-addresses", values);
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const addresssSlices = createSlice({
  name: "address",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAddress.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAddress.fulfilled, (state, action) => {
        state.isLoading = false;
        state.address = action.payload;
      })
      .addCase(getAddress.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createAddress.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAddress.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.address = action.payload;
        toast.success("Address created successfully!");
      })
      .addCase(createAddress.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;

        // Extract the error message from the payload
        const errorMessage =
          action.payload?.response?.data?.message?.[0] ||
          action.payload?.message ||
          "Failed to save address. Please try again.";

        // Display the error message using toast
        toast.error(errorMessage);
      });
  },
});

export default addresssSlices.reducer;
